import omit from 'lodash/omit';
import { Markdown } from 'platform-components';
// @ts-ignore
import customRules from 'platform-components/src/components/markdown/custom-rules';
import { MdState } from 'platform-components/src/components/marker/types';
import React from 'react';
import { defaultRules } from 'simple-markdown';

import { libraryBannersRule } from './_extension-rule/markdown_extension-rule_library-banners';
import { prepLessonsRule } from './_extension-rule/markdown_extension-rule_prep-lessons';
import { stackCardsRule } from './_extension-rule/markdown_extension-rule_stack-cards';

const forbiddenRules = ['input', 'marginRemover', 'resource'];

const rules = {
    ...libraryBannersRule,
    ...prepLessonsRule,
    ...stackCardsRule,
    ...defaultRules,
    ...omit(customRules, forbiddenRules),
};

interface Props {
    display?: 'block';
    mdState?: MdState;
    mix?: string;
    children: string;
}

export const MarkdownExtXContent = (props: Props) => <Markdown {...props} preParse={(s) => s} rules={rules} />;
